import angular from 'angular';

export default angular.module('components.document', [])
    .component('document', {
        bindings: {
            catalogid: '<',
            docid: '<',
            schema: '<',
            mode: '<'
        },
        template: require('./document.pug')(),
        controller: ['AuthenticationService', 'ZebraService', function(AuthenticationService, ZebraService) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.isAuthenticated = AuthenticationService.isAuthenticated();
                ctrl.schema = 'bibv1.1';
                ctrl.mode = 'full';
                ctrl.load();
            };

            ctrl.load = function() {
                var docid =  ctrl.docid.replace(/"/g, '\\"').replace(/\\/g, '\\\\');
                var query = 'rec.id="' + docid + '"';

                ctrl.loading = true;
                search(ctrl.catalogid, query, ctrl.schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(catalogid, query, schema, done) {
                var params = {};
                params.id = catalogid;
                params.operation = 'search';
                params.query = query;
                params.recordSchema = schema;
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .name;
